(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/retail-list/assets/javascripts/retail-list.js') >= 0) return;  svs.modules.push('/components/marketplace/retail-list/assets/javascripts/retail-list.js');

'use strict';

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const GroupList = svs.components.marketplace.groupList.GroupList;
const RetailListItem = svs.components.marketplace.retailList.RetailListItem;
const helpers = svs.components.marketplace.helpers;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const getRetailers = svs.components.marketplaceData.selectors.teams.getRetailers;
const selectChatRooms = svs.components.marketplaceData.selectors.chat.selectChatRooms;
const RetailList = _ref => {
  let isBrowseGames = _ref.isBrowseGames,
    children = _ref.children,
    renderOnEmpty = _ref.renderOnEmpty,
    teamClassName = _ref.teamClassName,
    teamLinkSearch = _ref.teamLinkSearch,
    maxGamesToDisplay = _ref.maxGamesToDisplay,
    offsetForLastClicked = _ref.offsetForLastClicked,
    shouldUseLastClicked = _ref.shouldUseLastClicked;
  const history = useHistory();
  const retailers = useSelector(state => getRetailers(state, isBrowseGames));
  const chatRooms = useSelector(state => selectChatRooms(state));
  const setLastClicked = _ref2 => {
    let teamId = _ref2.id;
    if (shouldUseLastClicked) {
      svs.components.Storage.browser.set('lastClickedTeam', 'marketplace', {
        groupId: teamId,
        offset: offsetForLastClicked
      });
    }
  };
  return React.createElement(GroupList, {
    listData: retailers,
    renderItem: (team, key) => React.createElement(RetailListItem, {
      className: teamClassName,
      history: history,
      isHeaderInverted: true,
      key: team.id || key,
      linkTo: {
        pathname: helpers.getRetailUrl(team.id, team.name),
        search: teamLinkSearch
      },
      maxGamesToDisplay: maxGamesToDisplay,
      onClick: () => setLastClicked(team),
      team: team,
      unreadMessages: (chatRooms["marketplace_".concat(team.id)] || {}).unread
    }, children(team)),
    renderOnEmpty: renderOnEmpty
  });
};
RetailList.defaultProps = {
  children: () => {}
};
setGlobal('svs.components.marketplace.retailList.RetailList', RetailList);

 })(window);